// extracted by mini-css-extract-plugin
export default {"Toggle":"Efj50Lkc","dot":"KBAy1xVE","active":"H2vZLo_8","m":"El_VqfS8","s":"hWJltKiA"};